// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"ScrollToTopButton_icomoon-font__3VJcu","ScrollToTopButton":"ScrollToTopButton_ScrollToTopButton__Er3t_"};